import * as React from "react"
import { cn } from "@shared/utils"

/**
 * Input component with styling and ref forwarding.
 *
 * Extends all native `<input>` props.
 *
 * @remarks
 * This input supports styling for file inputs, focus states, disabled state, and placeholder.
 *
 * @example
 * ```tsx
 * <Input placeholder="Enter your name" />
 * ```
 */
const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<'input'>>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          'flex h-9 w-full rounded-md border border-input bg-input px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)

Input.displayName = "Input"

export { Input }
